export const SIDE_NAV_OPEN = 'SIDE_NAV_OPEN'
export const SIDE_NAV_CLOSE = 'SIDE_NAV_CLOSE'
export const SIDE_NAV_RESET = 'SIDE_NAV_RESET'

export const LOGIN_TAB_OPEN = 'LOGIN_TAB_OPEN'
export const LOGIN_TAB_CLOSE = 'LOGIN_TAB_CLOSE'
export const LOGIN_TAB_RESET = 'LOGIN_TAB_RESET'

export const SIGNUP_TAB_OPEN = 'SIGNUP_TAB_OPEN'
export const SIGNUP_TAB_CLOSE = 'SIGNUP_TAB_CLOSE'
export const SIGNUP_TAB_RESET = 'SIGNUP_TAB_RESET'
